import { createReducer } from '@ngrx/store';

import { produceOn } from 'app/_state/produce-on';

import { toEntityInfoPageKey } from './entity-info-page-key';
import * as ACTIONS from './entity-info-page.actions';
import { initialState } from './entity-info-page.state';

const _entityInfoPageReducers = createReducer(initialState,
  // Set if the connection box is filtered to active or inactive
  produceOn(ACTIONS.SET_INFO_PAGE_FILTER_TEXT, (state, props) => {
    const key = toEntityInfoPageKey(props.payload?.key);
    if (!state.keyed_entity_info_pages[key]) {
      state.keyed_entity_info_pages[key] = {
        filterText: props.payload?.value?.filterText
      };
    } else {
      state.keyed_entity_info_pages[key].filterText = props?.payload?.value?.filterText;
    }
  })
);

export function entityInfoPageReducers(state, action) {
  return _entityInfoPageReducers(state, action);
}
